import { ComponentProps } from "react";

import { Box, Logo as SenekitLogo } from "@seneca/senekit";
import { LogoVariant } from "@seneca/senekit/out/components/content/Logo/consts";
import { ResponsiveProp } from "@seneca/senekit/out/types";

import { useSelector } from "seneca-common/utils/hooks/selectors";

import { getRegion } from "features/regions/selectors";

import useAppName from "../hooks/useAppName";
import useAppVariant from "../hooks/useAppVariant";
import { getAppVersion } from "../utils/functions/app";

export default function Logo(props: ComponentProps<typeof Box>) {
  const { height, width } = props;
  const variant = useLogoVariant();
  const appName = useAppName();
  const title = `${appName} ${getAppVersion()}`;

  return (
    <Box dataNoTranslate title={title} {...props}>
      <SenekitLogo
        variant={variant as LogoVariant}
        height={height}
        width={width as ResponsiveProp<string>}
      />
    </Box>
  );
}

function useLogoVariant() {
  const appVariant = useAppVariant();
  const region = useSelector(getRegion);

  const valuesByVariant = {
    seneca: region === "GB" ? "default" : "goStudent",
    senecaPrimary: "default",
    plurall: "plurall",
    goStudentLearning: "goStudentLearning"
  };

  return valuesByVariant[appVariant];
}
